<template>
	<div v-if="phase == 0 || phase == 1" class="holiday-savings-msg">
		<p v-html="msg['phase1'][text]"/>
	</div>
</template>

<script>
export default {
	name: "HolidaySavingsMsg",
	props: {
		phase: {
			type: [Number, String],
			default: 0
		},
		text: {
			type: [Number, String],
			default: 0
		}
	},
	computed: {
		msg() {
			return {
				phase1: { 
					configurator: "<p class='bold'>Get your NZXT H510 case on us.</p>",
					configurator2: "<p class='bold'>Celebrate with $69.99 off this Holiday!<br>Enjoy the savings.</p>",
					starterSeries: "<p>Your H510 case is on us.</p>",
					refurbishedBuildsCase: `<span class="highlight">The NZXT H510 case is on us.</span>`,
					refurbishedBuildsNonCase: `<span class="highlight">Celebrate with $69.99 off this Holiday! <br>Enjoy the savings.</span>`,
					refurbishedOverviewCase: `<span class="bold highlight">Get your NZXT H510 case on us.</span>`,
					refurbishedOverviewNonCase: `<span class="bold highlight">Celebrate with $69.99 off this Holiday! <br>Enjoy the savings.</span>`,
					streamingPC: "<p>Your H510 case is on us.</p>",
					creatorAndH1PC: "<p>Celebrate with $69.99 off this Holiday! <br>Enjoy the savings.</p>"
				}
			};
		}
	}
};
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";
.holiday-savings-msg {
	text-align: left;

	p {
		color: #640a92;
		margin: 0;
	}

	.highlight {
		color: #640a92;
	}

	.bold {
		font-weight: bold;
	}
}
</style>
